import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    getTodayDate,
    getType,
    selectDropdownStyle,
    dateFormat,
    getBranchId
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllProducts } from './../../../Helpers/apiCalls/Manage/Products';
import { getSalesPerProduct, getSalesPerProductPotato } from './../../../Helpers/apiCalls/Reports/DailyOrdersApi';
import { searchItem } from "../../../Helpers/apiCalls/itemsApi";
import { getCategory } from "../../../Helpers/apiCalls/categoryApi";
import TotalSales from "../../OfficeReports/TotalSales/TotalSales";
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

export default function RetailTopSellingPrice() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const today = Moment().format("MM/DD/YYYY");
    const [filterConfig, setFilterConfig] = useState({
        date_from: new Date(),
        date_to: new Date(),
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [allData, setAllData] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totalProfit, setTotalProfit] = useState(0);
    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };
    
    const xlsxHeaders = [
        "RANK",
        "ITEM DESCRIPTION",
        "ITEM CODE",
        "QTY SOLD",
        "REVENUE",
        "UNIT PRICE",
        "COST",
        "DISCOUNT",
        "PROFIT",
        "PROFIT MARGIN",
        "CATEGORY",
    ]

    const excelHeaders = [
        { label: "Product", key: "product" },
        { label: "Size", key: "size" },
        { label: "Price", key: "store_price" },
        { label: "Quantity", key: "qty" },
        { label: "Subtotal", key: "subtotal" },
        { label: "Discount", key: "discount" },
        { label: "Total Sales", key: "total_sales" },
    ];

    async function fetchBranches() {
        setBranches([])

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data
            .filter((data) => { return (data.is_franchise !== "3" && data.is_franchise !== "1")})
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.value === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
    }
    
    async function fetchItems() {
        setItems([])
        const response = await searchItem({});

        if (response.response) {
            var data = response.response.data.map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Products", value:""}, ...data]);
        }
    }

    async function fetchCategories() {
        setCategories([])
        const response = await getCategory({});
        if (response.data) {
        //categories
        var categories = response.data.data.map((category) => {
            var info = {}
            info.value = category.id
            info.label = category.name
            info.id = category.id
            // info.selected_value_name = "selected_category"
            return info
        })
        setCategories(categories);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setExcelData([])
        setTotalRevenue(0);
        setTotalCost(0);
        setTotalProfit(0);
        setTotalDiscount(0);
        setTotalItems(0)

        const response = await getSalesPerProduct(filterConfig);
        if (response.data) {

            var allItems = response.data.data.map((bill) => {
                var info = bill;
                return info;
            });
            setAllData(allItems)

            var excel = allItems.map((bill) => {
                var info = {};
                info.rank = bill.rank
                info.item_description = bill.item_description
                info.item_code = bill.item_code
                info.qty = bill.qty
                info.revenue = bill.revenue
                info.price = bill.price
                info.cost = bill.cost
                info.discount = bill.discount
                info.profit = bill.profit
                info.profit_margin = bill.profit_margin
                info.category = bill.category
                return info;
            });
            setExcelData(excel)

            var total_revenue = response.data.summary? response.data.summary.total_revenue : "0";
            var total_cost = response.data.summary? response.data.summary.total_cost : "0";
            var total_discount = response.data.summary? response.data.summary.total_discount : "0";
            var total_profit = response.data.summary? response.data.summary.total_profit : "0";
            setTotalRevenue(total_revenue);
            setTotalCost(total_cost);
            setTotalDiscount(total_discount);
            setTotalProfit(total_discount);
            setTotalItems(response.data.size);
        }
        setShowLoader(false);
    }
    
    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                product_id: "",
                branch_id: "",
                date_from: "",
                date_to: "",
            };
        });
    };

    function handleExport() {
        const rows = excelData
        const header = ['', '']
        const meta = [
            ['REPORT TITLE:', 'RETAIL TOP SELLING PRICE'],
            ['ITEM:', filterConfig.item_name !== '' && filterConfig.item_name !== undefined ? filterConfig.item_name : 'All Items'],
            ['BRANCH:', filterConfig.branch_name !== '' && filterConfig.branch_name !== undefined ? filterConfig.branch_name : 'All Branches'],
            ['CATEGORY:', filterConfig.category_name !== '' && filterConfig.category_name !== undefined ? filterConfig.category_name : 'All Categories'],
            ['DATE FROM:', filterConfig.date_from !== '' && filterConfig.date_from !== undefined ? dateFormat(filterConfig.date_from) : 'N/A'],
            ['DATE TO:', filterConfig.date_to !== '' && filterConfig.date_to !== undefined ? dateFormat(filterConfig.date_to) : 'N/A'],
            ['TOTAL REVENUE:', totalRevenue],
            ['TOTAL COST:', totalCost],
            ['TOTAL DISCOUNT:', totalDiscount],
            ['TOTAL PROFIT:', totalProfit],

        ];

        const sheet = XLSX.utils.json_to_sheet([{}], {
            header: header
        });

        /* generate worksheet and workbook */
        const workbook = XLSX.utils.book_new();
        XLSX.utils.sheet_add_json(sheet, rows, { origin: 'A12' });
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(sheet, meta, { origin: "A1" });
        XLSX.utils.sheet_add_aoa(sheet, [xlsxHeaders], { origin: "A12" });
        XLSX.writeFile(workbook, `RetailTopSellingItem (${Moment().format("MMM DD, YYYY")}).xlsx`, { compression: true });
    }

    useEffect(() => {
        fetchBranches();
        fetchItems()
        fetchCategories()
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> RETAIL TOP SELLING ITEM </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                        
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Item"
                            styles={selectDropdownStyle}
                            // value={branch}
                            options={items}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "item_id": e.value, "item_name": e.label };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={selectDropdownStyle}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "branch_id": e.value, "branch_name": e.label  };
                                });}}
                        />
                        </Col>
                        <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Category"
                            styles={selectDropdownStyle}
                            options={categories}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "category_id": e.value, "category_name": e.label  };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Revenue: {numberFormat(totalRevenue)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Cost: {numberFormat(totalCost)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Discount: {numberFormat(totalDiscount)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Profit: {numberFormat(totalProfit)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "RANK",
                                "ITEM DESCRIPTION",
                                "ITEM CODE",
                                "QTY SOLD",
                                "REVENUE",
                                "UNIT PRICE",
                                "COST",
                                "DISCOUNT",
                                "PROFIT",
                                "PROFIT MARGIN",
                                "CATEGORY",
                            ]}
                            headerSelector={[
                                "rank",
                                "item_description",
                                "item_code",
                                "qty",
                                "revenue",
                                "price",
                                "cost",
                                "discount",
                                "profit",
                                "profit_margin",
                                "category",
                            ]}
                            tableData={allData}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <div className="mb-3" />
                <br /><br />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>
            <Footer/>
        </div>
    );
}
